import { HttpClient } from "@angular/common/http";
import { BaseStore } from "../extends/base-store";
import { ValoresDonarStore } from "./valores-donar-store";
import { DescuentoNominaStore } from "./descnomina-store";
import { DeseaDiaVacacionalStore } from "./deseadiavacacional-store";
import { CertificadoStore } from "./certificado-donacion-store";

export class ListOfStore {
  private static store = {    
    ValoresDonarStore,
    DescuentoNominaStore,
    CertificadoStore,
    DeseaDiaVacacionalStore
  };
  private static instances: BaseStore[] = [];

  /**
   * @author Jose Wilson Mulato
   * @description obtiene en la lista las clases de almacenamiento para que los componente solicite el servicio y obtenga el contenido
   * @param nameStore
   * @param http
   */
  public static GetStore(nameStore: string, http?: HttpClient): BaseStore {
    this.instances[nameStore] = this.instances[nameStore] || new this.store[nameStore](http);
    return this.instances[nameStore];
  }
}



// WEBPACK FOOTER //
// ./src/app/store/list-of-store.ts